/* eslint-disable no-unused-vars */
import React from 'react';
import {
  colors, weight, Banner, Row, spaces, Div,
} from 'globalStyle';
import { ProjectProgressAndValue } from 'components/Bars';
import { routes } from 'routes';
import { Title, Text } from 'components/Texts';
import { useLocation } from 'wouter';
import { useMediaQuery } from 'hooks';
import styled, { keyframes } from 'styled-components';
import Box from '@material-ui/core/Box';

export const Card2 = ({
  tag,
  companyName,
  projectName,
  shortDescription,
  currentAmount,
  percent,
  photoPortrait,
  daysLeft,
  category,
  height,
  isFeaturedProject,
  goals,
  images,
}) => {
  const [location, setLocation] = useLocation();
  const isDesktop = useMediaQuery();
  const imagen = images[0];
  if (!tag) return null;
  return (
    <Body height={height}>
      <Banner
        isCover
        isCenter
        style={{ position: 'relative', borderRadius: '11px', overflow: 'hidden' }}
        img={imagen}
        height="100%"
        width="100%"
      >
        <BackgroundColor />
        {isFeaturedProject && (
          <>
            <Row pt={15} pr={15} content="flex-end">
              <FeaturedProjectCategory>
                {category}

              </FeaturedProjectCategory>
            </Row>
            <FeaturedProjectTag
              ml={10}
              mt={10}
            >
              PROYECTO DESTACADO
            </FeaturedProjectTag>
          </>
        )}
        <Content onClick={() => setLocation(`${routes.project.route}${tag}`)}>
          <Grid>
            <Title
              size={isDesktop ? 18 : 12}
              isOverflow
            >
              {projectName}

            </Title>
            <Text
              size={isDesktop ? 16 : 10}
              isOverflow
            >
              {companyName}
            </Text>
          </Grid>
          <Description>
            <Text
              size={isDesktop ? 13 : 9}
              isOverflowy
              height={isDesktop ? '90px' : '30px'}
              mb={20}
            >
              {shortDescription}
            </Text>
            <Box>
              <ProjectProgressAndValue
                isDesktop={isDesktop}
                currentAmount={currentAmount}
                percent={percent}
                remaining={daysLeft}
                min={goals?.min}
              />
            </Box>
          </Description>
        </Content>
      </Banner>
    </Body>
  );
};

const moveUp = keyframes`
    from {
        height: 0px;
        padding-top: 0px;
    }

    to {
        height: 200px;
        padding-top: 20px;
    }
`;

const moveUpSm = keyframes`
    from {
        height: 0px;
    }

    to {
        height: 200px;
    }
`;

export const NextRelease = styled.div`
    ${spaces}
    color: ${colors.tertiary};
    font-weight: ${weight.BOLD};
    text-transform: uppercase;
    display: none;
`;

export const Description = styled.div`
    overflow: hidden;
    ${spaces}
    display: none;
    height: 200px;
    padding-top: 20px;
    animation: ${moveUp} .4s ease-in;
    @media (max-width: 768px) {
      padding-top: 5px;
      animation: ${moveUpSm} .4s ease-in;
    }
`;

export const Content = styled.div`
    ${spaces}
    width: 95%;
    margin: 0 auto;
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    padding: 1em;
    background-color: ${colors.WHITE};
    border-radius: 11px;
    max-height: 70%;
`;

export const Body = styled.div`
    border-radius: 11px;
    height: ${(props) => props.height || '380'}px;  
    width: 100%;
    &:hover{
      
        div${Content}{
          cursor: pointer;
        }

        div${Description}, div${NextRelease}{
            display: block;
        }
    }
    &:click{
      
      div${Content}{
        cursor: pointer;
      }

      div${Description}, div${NextRelease}{
          display: block;
      }
  }
`;

export const BackgroundColor = styled.div`
    background-color: rgba(0,0,0,0.10);
    height: 100%;
    width: 100%;
    position: absolute;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
`;

export const Grid = styled.div`
    ${spaces}
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 0px 14px;
`;

export const TagNextRelease = styled.div`
    position: absolute;
    top: 15px;
    left: 10px;
    z-index: 1;
    ${spaces}
    font-size: 12px;
    font-weight: ${weight.BOLD};
    border-radius: 12px;
    background-color: ${colors.tertiary};
    color: ${colors.WHITE};
    padding: .3em .6em;
`;

export const FeaturedProjectTag = styled.div`
    position: absolute;
    font-weight: ${weight.BOLD};
    color: ${colors.GRAY_1};
    top: 15px;
    left: -10px;
    background-color: ${colors.secondary};
    padding: .5em 2em;
    text-transform: uppercase;
`;

export const FeaturedProjectCategory = styled.div`
    font-size: 12px;
    font-weight: ${weight.BOLD};
    border-radius: 15px;
    display: inline-block;
    border: 2px solid ${colors.secondary};
    color: ${colors.secondary};
    padding: 1em;
    z-index: 5;
`;
